import React from 'react'

function CheckBoxEmptyIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
    >
      <rect x="1" y="0.5" width="19" height="19" rx="3.5" fill="#F4F0F9" stroke="#9E7AC3" strokeWidth="1.5" />
    </svg>
  )
}

export default CheckBoxEmptyIcon
